export const isLoading = (state) => state.oppv.isLoading
export const isSuccess = (state) => state.oppv.isSuccess
export const oppv = (state) => state.oppv.oppv
export const isError = (state) => state.oppv.error
